import { Dialog, Theme, useMediaQuery } from '@mui/material';
import { useLocation } from 'react-router-dom';

import { SettingsMenu } from 'components';
import { IAppSettingsContext } from 'context';
import { useAppSettings } from 'hooks';
import { useAppSelector } from 'store';
import { selectUser } from 'store/user';
import { isHipaaLink } from '../../../config/productProfile';

import styles from './ModulesContainer.module.scss';
import { withOutsideClickPreventer } from 'utils';

export function ModulesContainer() {
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));
  const location = useLocation();
  const user = useAppSelector(selectUser);

  const { open, closeSettings }: IAppSettingsContext = useAppSettings();

  if (isDesktop || !open) return null;

  const isVia3HomePage = !isHipaaLink && location.pathname === '/' && !user;
  const isPatientWaitingRoom = !isHipaaLink && location.pathname !== '/' && !user;
  const isLoginPage = location.pathname === '/login';
  const forceLightTheme = isVia3HomePage || isPatientWaitingRoom || isLoginPage;

  return (
    <Dialog className={styles.dialog} open={open} onClose={withOutsideClickPreventer(closeSettings)}>
      <div className={styles.container}>
        <SettingsMenu
          className={styles.settings}
          withBackground
          onClose={closeSettings}
          forceLightTheme={forceLightTheme}
        />
      </div>
    </Dialog>
  );
}
